export default {
	personalCenter: {
		vip_member: 'VIP會員',
		vip: {
			level_label: 'VIP{level} 等級', next_level: '下一階級：VIP{level}',
			points_summary: '目前累計 {current} 經驗{level}還需 {remaining} 經驗',
			level_rewards: '等級獎勵', reward_title: 'VIP{level} 獎勵', exclusive_rewards: '專屬獎勵', promotion_reward: 'VIP{level} 晉升獎勵',
			previous_level: '上一個等級', next_level_button: '下一個等級',
			dragon_key: '龍魂秘鑰 ×{count}', battle_shard: '戰紋碎片 ×{count}', forge_crystal: '鍛造靈晶 ×{count}',
			unlocked: '已達成 VIP{level}，可立即領取。', locked: '尚未達成 VIP{level}。',
			claim: '領取', claiming: '領取中...', claimed: '已領取', claim_success: 'VIP{level} 獎勵已領取', claim_failed: '領取失敗，請稍後重試',
			points_label: '積分', go_redeem: '前往兌換',
			experience_summary: '目前累計 {current} 經驗；距離VIP{level}還需 {remaining} 經驗',
			max_level: '恭喜，您已滿級', current_experience: '目前經驗值 {current}'
		},
		title: '個人中心', my_exchange: '我的兌換', my_points: '我的積分', lottery_records: '抽獎記錄', recharge_records: '儲值記錄',
		redeem_gift: '兌換禮包', redeem_description: '輸入兌換碼後，獎勵將發放到目前選擇的角色。', redeem_code: '兌換碼', redeem_code_placeholder: '請輸入兌換碼', redeeming: '兌換中...', redeem_now: '立即兌換', rebate_coupon: '{percent}%返利券',
		points_details: '積分明細', exchange_time: '兌換時間', reward_content: '獎勵內容', status: '狀態', time: '時間', type: '類型', points_change: '積分變動', balance: '餘額', lottery_time: '抽獎時間', reward: '獎勵',
		order_id: '訂單號', payment_channel: '支付渠道', amount: '金額', server: '伺服器', role: '角色', payment_time: '支付時間', copy: '複製',
		loading: '載入中...', no_records: '沒有符合的記錄', no_content: '目前沒有可顯示的內容。', previous: '上一頁', next: '下一頁', page_info: '第 {current} / {total} 頁',
		source_recharge_reward: '儲值獎勵', source_official_activity: '官網活動', source_item_exchange: '道具兌換',
		exchange_success: '兌換成功', exchange_failed: '兌換失敗', enter_redeem_code: '請輸入兌換碼', exchange_retry: '兌換失敗，請稍後重試',
		copy_success: '複製成功', copy_failed: '複製失敗', lottery_load_failed: '抽獎記錄載入失敗', lottery_load_retry: '抽獎記錄載入失敗，請稍後重試',
		recharge_load_failed: '儲值記錄載入失敗', recharge_load_retry: '儲值記錄載入失敗，請稍後重試', points_load_failed: '積分記錄載入失敗', points_load_retry: '積分記錄載入失敗，請稍後重試',
		exchange_records_load_failed: '兌換記錄載入失敗', exchange_records_load_retry: '兌換記錄載入失敗，請稍後重試'
	},
	member_popup: {
		title: '恭喜！會員積分已增加',
		message: '本次儲值獲得 {points} 點會員積分，距離晉升「VIP{nextLevel}」還需 {remaining} 點。',
		progress: '累計儲值積分 {current} / {target}',
		next: '距離晉升VIP{nextLevel}還需 {remaining} 積分',
		suppress: '7天內不再提示',
		later: '稍後再說',
		rewards: '前往領取獎勵',
		close: '關閉會員積分提示'
	},
	member_level: {
		title: '會員等級',
		points_progress: '累計儲值積分',
		next_level: '距離晉升VIP{level}還需',
		points_unit: '積分',
		view_rewards: '查看等級獎勵'
	},
	login_button_text: '登入',
	logining_button_text: '登入中',
	account_input_text: '請輸入郵件地址',
	password_input_text: '請輸入密碼',
	other_login_methods_text: '其他登入方式',
	top_up_center_text: '儲值中心',
	benefit_text: '福利',
	sign_in_text: '登入',
	log_out_text: '登出',
	service_terms_text: '服務條款',
	privacy_policy_text: '隱私政策',
	official_apk_download_text: '官方APK版本下載',
	official_facebook_text: '官方粉絲頁',
	recharge_instructions_text: '儲值說明',	rebate_countdown_title: '限時返利開啟中',
	rebate_countdown_label: '倒計時',
	rebate_countdown_days: '天',
	rebate_countdown_hours: '時',
	rebate_countdown_minutes: '分',
	rebate_countdown_seconds: '秒',	log_in_game_account_text: '請登入遊戲帳號',
	sign_in_lowercase_text: '登入',
	instructions_text: '說明',
	confirm_text: '確認',
	switch_character_text: '切換角色',
	copy_successful_text: '複製成功',
	claimed_text: '已領取',
	claim_success_text: '領取成功',
	claim_text: '領取',
	claim_unmet_text: '不滿足',
	contact_customer_service_text: '聯絡客服',
	home_page_text: '主頁',
	payment_successful_text: '付款成功',
	purchase_confirm_text: '確認購買',
	payment_channels_text: '付款渠道',
	payment_button_text: '購買',
	original_price_text: '原價',
	discounts_text: '折扣',
	earn_points_text: '獲得積分',
	rebates_text: '返利',
	amount_text: '價格',
	insufficient_points_text: '積分不足',
	insufficient_lottery_count_text: '抽獎次數不足',
	network_error_retry_text: '網路錯誤，請稍後再試',
	score_lottery_text: '積分抽獎',
	score_lottery_entrance_error: '請求積分抽獎入口接口出錯:',
	lottery_current_points_label: '當前積分:',
	lottery_points_recharge_tip: '積分可通過儲值獲得',
	lottery_spin_label: '轉盤抽獎',
	lottery_rule_button: '規則詳情',
	lottery_rule_popup_title: '活動規則',
	lottery_record_button: '獲獎記錄',
	lottery_record_title: '獲獎記錄',
	lottery_record_empty: '暫無記錄',
	lottery_record_time: '時間',
	lottery_record_prize: '獎品內容',
	lottery_daily_limit: '今日已達上限',
	lottery_remaining_count: '剩餘次數 {count}',
	lottery_draw_cost: '{cost}積分/次',
	lottery_init_data_error: '請求積分抽獎資料接口出錯:',
	daily_rewards_text: '每日獎勵',
	points_text: '積分商城',
	winning_award_text: "恭喜獲獎",
	points_limit_tips_text: "該獎勵已領取完畢，請等待冷卻時間結束後再次兌換～",
	receive_reward_tips_text: "獎勵已發送至您角色的郵箱，請登入遊戲角色領取！",
	hot_title_text: "儲值有禮",
	other_title_text: "Enjoy儲值",
	limit_title_text: "首儲返利",
	limit_text: "限購",
	ingame_title_text: "點卡",
	sell_out_text: "售罄",
	copy_fail_text: '複製失敗',
	payment_type_text: '支付管道',
	order_id_text: '訂單號',
	payment_time_text: '支付時間',
	copy_text: '複製',
	amount_text: '金額',
	game_server_text: '伺服器',
	game_role_text: '角色',
	orders_records_text: '儲值記錄',
	no_data_text: '暫無數據',
	orders_tips_text: '根據系統設定，儲值記錄查詢範圍限定為最近30天內的訂單資訊',
	pointsDescribeText: '',
	pointsBalanceText: '',
	points_period_daily: '本日',
	points_period_week: '本週',
	points_period_month: '本月',
	points_period_lifetime: '終身',
	points_tag_mustBuy: '必買',
	points_tag_selected: '精選',
	points_tag_discount: '優惠',
	points_tag_perk: '福利',
	coupon: {
		discount_label: '返利券',
		title_html: '使用返利券購買後可額外獲得返利。',
		expired_text: '已失效',
		used_text: '已使用',
		countdown_prefix: '倒計時',
		activity_button_text: '返利券抽獎'
	},
	pagination: {
		previous: "上一頁",
		next: "下一頁",
		page_info: "第 {current} 頁 / 共 {total} 頁"
	},
	support_my_questions: '我的問題',
	support_submit_issue: '提交問題',
	support_records_title: '我的問題記錄',
	support_records_desc: '查看處理進度，也可以繼續補充資料。',
	support_refresh: '刷新',
	support_tabs_label: '客服選項',
	support_load_more: '載入更多',
	support_user_id: 'User ID',
	support_game: '遊戲',
	support_platform: '平台',
	support_back: '返回',
	support_mark_solved: '已解決',
	support_official_support: '官方客服',
	support_image: '圖片',
	support_reply_hint: '您的補充資訊將發送給客服',
	support_send: '發送',
	support_sending: '發送中...',
	support_player: '玩家',
	support_attachment_preview: '附件預覽',
	support_remove_attachment: '移除附件',
	support_attachment_fallback: '附件',
	support_survey_title: '問卷調查提示',
	support_survey_message: '您的問題是否已解決？',
	support_survey_close: '關閉',
	support_submit_success: '提交成功',
	support_submit_fail: '提交失敗',
	support_close_success: '已關閉聊天',
	support_close_fail: '關閉失敗',
	support_rate_title: '請對本次服務做出評價',
	support_input_placeholder: '請輸入內容...',
	support_image_pick_error: '未獲取到圖片路徑',
	support_send_fail: '發送失敗',
	support_evaluate_success: '評價成功',
	support_evaluate_fail: '評價失敗',
	support_status_unreplied: '未回覆',
	support_status_replied: '已回覆',
	support_status_resolved: '已解決',
	support_status_pending_review: '待評價',
	support_form_type_label: '問題類型',
	support_form_type_placeholder: '請選擇問題類型',
	support_form_desc_label: '問題描述',
	support_form_desc_placeholder: '請詳細描述您遇到的問題...',
	support_form_upload_label: '上傳附件',
	support_form_upload_click: '點擊上傳檔案',
	support_form_upload_tips: '(截圖≤10MB，影片≤50MB，最多5個)',
	support_form_submit: '確認提交',
	support_form_image_too_big: '圖片大小不能超過10MB',
	support_form_video_too_big: '影片大小不能超過50MB',
	cancel_text: '取消',
	support_submitting: '提交中...',
	// Support types
	support_type_topup: '儲值問題',
	support_type_account: '帳號問題',
	support_type_guide: '遊戲指導',
	support_type_suggestion: '意見建議',
	support_type_event: '活動問題',
	support_type_report: '違規檢舉',
	support_type_other: '其他問題',
	support_type_topup_hint: '儲值未到帳、金額異常',
	support_type_account_hint: '登入、封禁、綁定問題',
	support_type_guide_hint: '玩法、任務、進度問題',
	support_type_suggestion_hint: '回饋與建議',
	support_type_report_hint: '作弊、辱罵、違規檢舉',
	support_type_other_hint: '其他未分類問題',
	support_type_topup_code: '儲',
	support_type_account_code: '號',
	support_type_guide_code: '導',
	support_type_suggestion_code: '議',
	support_type_report_code: '舉',
	support_type_other_code: '其',
	couponLottery: {
		rules_btn: '使用規則',
		daily_draw_title: '每日返利券抽獎',
		unlocked_extra: '剩餘: {amount} 次',
		draws_used_up: '今天的獎券已用完',
		unlock_extra_tip: '今日儲值滿  ${amount} 即可解鎖額外抽獎機會！',
		tab_lucky_draw: '鴻運當頭抽大獎',
		tab_my_coupons: '我的優惠券',
		current_pool: '當前獎池（今日已參與）',
		current_pool_not: '當前獎池（今日未參與）',
		unit_people: '人',
		next_draw: '下次開獎时间',
		tomorrow: '明日',
		countdown_prefix: '距離開獎：',
		reward_info: '獎品信息',
		reward_label: '獎品：',
		winners_label: '中獎人數：',
		max_use_label: '最高可用於：',
		validity_label: '券有效期：',
		unit_piece: '個',
		recharge_amount: '${amount}儲值',
		validity_hours: '領取後{hours}小時',
		participation_rules: '參與規則',
		rule_1: '當日於官網進行任意金額儲值，即自動進入獎池',
		rule_2: '獎池人數需≥10人方可開獎，滿足開獎條件時，將於次日上午10:00開獎',
		rule_3: '中獎獎品為50%返利券，僅限用於$49.99及以下之儲值',
		rule_4: '詳細活動規則可點選右上角使用規則查閱',
		view_results_now: '立即查看開獎結果',
		recent_winners: '近期中獎名單',
		player_name: '玩家名稱',
		redeem_code_title: '兌換碼兌換',
		redeem_code_sub: '輸入兌換碼即可獲得專屬返利券',
		redeem_code_placeholder: '請輸入兌換碼',
		redeem_btn: '兌換',
		redeem_tip: '兌換碼區分大小寫，請按原樣輸入。每個兌換碼僅限使用一次。兌換成功的返利券將自動發放至您的帳戶。',
		available_coupons: '可用返利券 ({count})',
		rebate_coupon: '返利券',
		remaining_time: '剩餘時間',
		obtained_at: '獲得時間：',
		status_available: '可使用',
		limit_use: '（僅限${amount}及以下使用）',
		popup_draw_title: '返利券抽獎',
		popup_draw_sub: '快來測試您的好運吧！',
		popup_confirm: '确定',
		popup_probs_title: '概率公示',
		popup_prob: '{label}%返利券：{value}%',
		result_congrats: '恭喜您獲得 <span class="highlight">{percent}</span> 返利券！',
		result_validity: '領取後{hours}小時內有效',
		confirm: '確認',
		lose_title: '未中獎',
		lose_main: '很抱歉，這次您沒有中獎',
		lose_sub: '明天再試試手氣吧！',
		win_title: '恭喜中獎！',
		win_main: '您獲得了 {percent} 返利券！',
		win_sub: '${amount} 及以下可用，有效期 {hours} 小時',
		rules_popup_title: '規則說明',
		rules_rebate_title: '返利說明',
		rules_rebate_base_title: '1. 基礎返利 (固定10%)',
		rules_rebate_base_desc: '在官網儲值任意金額，即可立即獲得 10% 額外贈送。',
		rules_rebate_base_example: '範例：儲值100城主幣，實際到帳110城主幣。',
		rules_rebate_draw_title: '2. 返利券抽獎 (隨機獲得10%~30%返利券)',
		rules_rebate_draw_desc_1: '透過抽獎可獲得返利券，券上返利比例可疊加在基礎返利之上。',
		rules_rebate_draw_desc_2: '返利總額上限為 40% (即基礎10% + 返利券最高30%)。',
		rules_rebate_draw_example: '範例：若您儲值100城主幣，且使用一張 30% 返利券：最終到帳城主幣 = 100城主幣 x (1 + 10%基礎 + 30%券) = 140城主幣 (總返利40%)',
		rules_chance_title: '取得抽獎機會',
		rules_chance_login_desc: '每日登入獎勵：每天首次登入官網，即可獲得 1次免費抽獎機會。',
		rules_chance_recharge_title: '儲值額外獎勵：單日累計儲值達到以下金額，可解鎖額外抽獎機會 (每日最多3次額外機會) ：',
		rules_chance_recharge_item_1: '儲值滿 $1600 -> 額外1次抽獎',
		rules_chance_recharge_item_2: '儲值滿 $2580 -> 額外2次抽獎',
		rules_chance_recharge_item_3: '儲值滿 $3200 -> 額外3次抽獎',
		rules_chance_limit: '單日抽獎總次數上限為 4次 (免費1次 + 額外最多3次)。',
		rules_chance_rates_title: '抽獎概率：',
		rules_chance_rate_10: '10% 返利券：65%',
		rules_chance_rate_15: '15% 返利券：25%',
		rules_chance_rate_20: '20% 返利券：8%',
		rules_chance_rate_25: '25% 返利券：10%',
		rules_chance_rate_30: '30% 返利券：3%',
		rules_chance_rate_50: '50% 返利券：5%',
		rules_usage_title: '使用返利券',
		rules_usage_item_1: '返利券 有效期為24小時 (自獲得起算)，請及時使用。',
		rules_usage_item_2: '返利券僅適用於官網直接儲值，不適用於第三方代儲或禮品卡。',
		rules_usage_item_3: '官網中的禮包商品不適用於返利券。',
		rules_usage_item_4: '大額匯款暫不參與上述返利活動。',
		rules_activity_title: '《鴻運當頭大獎》活動規則',
		rules_activity_slogan: '🧧 每日官網儲值，日日有機會抽大獎！鴻運當頭就是你，立即行動搶先機！',
		rules_activity_qual_title: '【參加資格】',
		rules_activity_qual_item_1: '於活動期間內，在每日 00:00 至 23:59(UTC+8)透過遊戲官方網站完成任意金額的第三方儲值。',
		rules_activity_qual_item_2: '符合資格的玩家將自動計入當日抽獎池，無需另外登記。',
		rules_activity_mech_title: '【開獎機制】',
		rules_activity_mech_item_1: '開獎時間：每日上午 10:00 (UTC+8)進行開獎',
		rules_activity_mech_item_2: '開獎範圍：前一日 00:00-23:59 (UTC+8)期間有進行官網儲值之玩家',
		rules_activity_mech_item_3: '開獎條件：當日獎池人數須 ≥10 人方可開獎，若未達指定人數，當日將取消開獎，不另行補抽',
		rules_activity_mech_item_4: '名單查詢：可於獎池介面查看每日獎池獲獎名單。',
		rules_activity_reward_title: '【獎項內容】',
		rules_activity_reward_item: '50%返利券 x1',
		rules_activity_reward_usage_title: '【50%返利券使用規則】',
		rules_activity_reward_usage_item_1: '適用範圍：最高可用於 $49.99 (NT$1,690) 儲值項目',
		rules_activity_reward_usage_item_2: '使用方式：儲值時點擊代金券後，介面儲值返利比例提示會自動變為加上50%後的比例，此時使用代金券儲值可獲得50%返利。',
		rules_activity_reward_usage_item_3: '有效期限：領取後 24小時內 須使用，逾期失效',
		rules_activity_reward_usage_item_4: '注意事項：每筆儲值限用一張，不可與其他返利券併用。每名當日儲值玩家每日僅計入一次抽獎資格，不限儲值次數，但資格不累計。',
		rules_activity_notes_title: '【注意事項】',
		rules_activity_notes_item_1: '本活動僅限官網第三方儲值，遊戲內儲值不列入計算',
		rules_activity_notes_item_2: '若出現惡意刷儲退款、虛假儲值等維規行為，一經查實，將取消活動資格，收回已領取獎勵',
		rules_activity_notes_item_3: '本活動最終解釋權歸營運團隊所有',
		time_h_m: '{hours}小時{minutes}分鐘',
		time_h_m_s: '{hours} 小時 {minutes} 分鐘 {seconds} 秒',
		coupon_alt: '優惠券',
		rebate_coupon_with_value: '{percent}返利券',
		banner_title: '幸運返利',
		banner_subtitle: 'Lucky Payback',
		msg_5003: '未到達開獎時間！',
		msg_5004: '未中獎！',
		msg_3003: '昨日未參與獎池！',
		msg_3004: '未到達開獎人數！',
		msg_1000: '恭喜中奖',
		btn_check_result: '立即查看開獎結果',
		btn_not_participated: '昨日未參與獎池',
		btn_won: '恭喜中獎',
		btn_not_won: '開獎結果：未中獎',
		btn_insufficient_participants: '昨日參與人數不足',
		exchange_success: "兑换成功！",
		exchange_failed: "兑换失败，请稍后重试。"
	},
	rebate_limited_text: '🔥 限時{pct}%返利',
	rebate_percent_text: '{pct}%返利',
	coupon_booster_label: '返利券',
	coupon_expires_after: '{time}後到期',
	coupon_threshold_shortfall: '還差 {amount} 可用',
	coupon_product_excluded: '目前商品不可使用',
	coupon_channel_restricted: '僅限 {channels} 支付',
	coupon_unavailable_title: '不可用優惠券',
	coupon_skip_text: '暫不使用優惠券',
	coupon_count_unit: '張',
	coupon_picker_title: '選擇優惠方式',
	coupon_entry_label: '優惠券',
	coupon_available_count: '{count}張可用',
	coupon_no_use_text: '不使用優惠券',
	coupon_best_tag: '最優',
	coupon_expired_text: '已到期',
	close_text: '關閉',
	discount_coupon_label: '滿減券',
	coupon_single_use_hint: '滿減券與返利券不可同時使用，每筆訂單限選一張',
	order_amount_text: '商品金額',
	discount_amount_text: '優惠抵扣',
	payable_amount_text: '應付金額',
	coupon_extra_rebate_notice: '額外50%返利部分將透過郵件發放，請聯繫客服登記發放。',
	payment_recommended_text: '推薦支付',
	payment_enjoy_rebate: '享{pct}%返利',
	payment_order_rebate: '本單返利 {amount}',
	payment_order_discount: '本單優惠 {amount}',
	recommend_text: '推薦',
	payment_other_methods_text: '其他支付方式',
	super_coupon_title: '限時神券',
	super_coupon_end_time: '活動結束時間：',
	super_coupon_previous_activity: '上一個神券活動',
	super_coupon_recommended: '超值推薦',
	super_coupon_view_details: '查看神券包詳情',
	super_coupon_value_label: '真實折扣價值',
	super_coupon_contents: '神券包內容',
	super_coupon_threshold: '滿 {amount}',
	super_coupon_discount: '減 {amount}',
	super_coupon_remaining: '剩餘 {time}',
	super_coupon_purchased: '已購買',
	super_coupon_buy_now: '立即購買',
	super_coupon_next_activity: '下一個神券活動',
	super_coupon_switcher: '神券活動切換',
	super_coupon_switch_to: '切換至第 {index} 個神券活動',
	super_coupon_details_title: '神券包詳情',
	super_coupon_close_details: '關閉神券包詳情',
	super_coupon_empty: '目前沒有滿減券',
	super_coupon_instructions: '使用說明',
	super_coupon_confirm: '知道了',
	super_coupon_package_name: '神券包',
	super_coupon_get_coupons: '購買立得 {count} 張滿減券',
	super_coupon_reward_multiple: '約 {multiple} 倍回饋',
	super_coupon_purchase_limit: '每次限購 {count} 組',
	super_coupon_purchase_interval: '購買間隔 {days} 天',
	super_coupon_rule_separator: '，',
	super_coupon_unknown_status: '狀態未知',
	super_coupon_date_format: '{year}年{month}月{day}日 {time}',
	super_coupon_used: '已使用',
	super_coupon_expired: '已過期',
	super_coupon_unit_day: '天',
	super_coupon_unit_days: '天',
	super_coupon_unit_hour: '小時',
	super_coupon_unit_hours: '小時',
	super_coupon_unit_minute: '分鐘',
	super_coupon_unit_minutes: '分鐘',
	super_coupon_valid_for: '{value} {unit}內有效'
}
